<template>
  <div>
    <BreadCrumb class="bread" :breads="['商品管理','商品分类']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">商品分类</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="分类名称">
            <el-input v-model="ruleForm.name" maxlength="20"></el-input>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button class="queryBtn" size="small" type="primary" @click="getList('cl')">查询</el-button>
            <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="operate-con" v-show="$store.getters.authority({name:'shopCategory',type:'add'})">
      <el-button size="small" @click="openAdd('')">新增</el-button>
    </div>
    <!-- <div class="table-con">
            <el-table :data="tableList" stripe v-loading="loading">
                <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="一级分类" align="center">
                    <span slot-scope="scope">{{scope.row.p_category_name ? scope.row.p_category_name :
                        scope.row.category_name}}</span>
                </el-table-column>
                <el-table-column label="二级分类" align="center">
                    <span slot-scope="scope">{{scope.row.p_category_name ? scope.row.category_name : ""}}</span>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
                <el-table-column label="备注" align="center" prop="note"></el-table-column>
                <el-table-column label="操作" align="center">
                    <div slot-scope="scope">
                        <el-button type="primary" size="small" @click="openView(scope.row.id)">查看</el-button>
                        <el-button type="primary" size="small" @click="openUpdate(scope.row.id)" v-show="$store.getters.authority({name:'shopCategory',type:'update'})">修改</el-button>
                        <el-button type="danger" size="small" @click="deleteData(scope.row.id)" v-show="$store.getters.authority({name:'shopCategory',type:'delete'})">删除</el-button>
                    </div>
                </el-table-column>
            </el-table>
    </div>-->
    <div class="container">
      <class-ification
        v-for="(obj,i) of dataArr"
        v-loading="loading"
        :datas="obj"
        :index="i + ''"
        :key="obj"
        @Click="Clicks"
        @showHide="refreshFun"
        v-show="$store.getters.authority({name:'shopCategory',type:'view'})"
      ></class-ification>
    </div>
    <div class="paginationWrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNum"
        :layout="pageLayout"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增-->
    <el-dialog class="dialogMY" :visible.sync="showDialog" width="400px" center>
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="80px">
        <el-form-item label="分类名称" prop="label">
          <el-input
            class="customIpt"
            v-model="ruleForm.label"
            size="small"
            placeholder="请输入分类名称"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <div class="footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button @click="confirm('ruleForm')" type="primary">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--修改-->
    <el-dialog class="dialogMY" :visible.sync="modifyshowDialog" width="400px" center>
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="80px">
        <el-form-item label="分类名称" prop="label">
          <el-input
            class="customIpt"
            v-model="ruleForm.label"
            size="small"
            placeholder="请输入分类名称"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <div class="Main"></div>
        <div class="footer">
          <el-button @click="modifyshowDialog = false">取 消</el-button>
          <el-button @click="modifyconfirm('ruleForm')" type="primary">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--删除-->
    <el-dialog class="dialogMY" :visible.sync="removeDialog" width="400px" center>
      <div slot="title">
        <i class="el-icon-warning"></i>
      </div>
      <div class="Main">
        <div class="infoOne">确定要删除吗？</div>
        <div class="infoTwo">你将无法恢复这条数据！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDialog = false">取 消</el-button>
        <el-button type="danger" @click="remove()">删 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import classification from "@/components/Classification";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import listMixin from "@/mixins/list";
export default {
  name: "shoppingCategory",
  data() {
    var validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入商品分类"));
      }
      if (value.trim().length <= 0) {
        callback(new Error("不允许输入空格"));
      }
      let reg = /^[0-9a-zA-Z_\u4e00-\u9fa5]{1,}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入中文、字母、数字、下划线、字符"));
      }
      callback();
    };
    return {
      search: {},
      showDialog: false,
      modifyshowDialog: false,
      removeDialog: false,
      removeData: "",
      loading: false,
      dataArr: [],
      total: 0,
      ruleForm: {
        label: "",
        p_category_name: ""
      },
      rules: {
        label: [
          {
            required: true,
            validator: validateName,
            trigger: "change"
          }
        ]
      }
    };
  },
  mixins: [listMixin],
  components: {
    BreadCrumb,
    "class-ification": classification
  },
  created() {
    this.getList();
  },
  methods: {
    getList(thatType = "") {
      this.loading = true;
      let params = {
        name: this.ruleForm.name
      };
      this.$axios.get(apis.category_list, { params }).then(data => {
        if (data.data.code == 200) {
          this.loading = false;
          let datas = data.data;
          let {
            pagination: { page_index, page_size, total }
          } = datas;
          this.dataArr = datas.data;
          this.total = datas.pagination.total;
        }
      });
    },
    Clicks(obj, i, index, type) {
      if (i == 1) {
        this.ruleForm.label = "";
        this.pid = obj.id;
        this.showDialog = true;
      } else if (i == 2) {
        this.pid = obj.id;
        this.ruleForm.label = obj.label;
        this.modifyshowDialog = true;
      } else {
        this.pid = obj.id;
        this.removeDialog = true;
      }
    },
    confirm(formName) {
      let url = `${apis.category_add}`;
      let jsonData = {
        pid: this.pid,
        category_name: this.ruleForm.label
      };
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios.post(url, jsonData).then(data => {
            let datas = data.data;
            if (datas.code == 200) {
              this.$message({
                type: "success",
                message: datas.msg
              });
              this.ruleForm.label = "";
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: datas.msg
              });
            }
          });
          this.showDialog = false;
        }
      });
    },
    modifyconfirm(formName) {
      let jsonData = {
        pid: this.pid,
        category_name: this.ruleForm.label
      };
      this.$refs[formName].validate(valid => {
        if (valid) {
          let url = `${apis.category_update}/${this.pid}`;
          this.$axios.post(url, jsonData).then(data => {
            let datas = data.data;
            if (datas.code == 200) {
              this.$message({
                type: "success",
                message: datas.msg
              });
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: datas.msg
              });
            }
          });
          this.modifyshowDialog = false;
        }
      });
    },
    removeClick(data) {
      this.removeData = data;
      this.removeDialog = true;
    },
    remove(data) {
      let url = `${apis.category_delete}/${this.pid}`;
      this.$axios.delete(url).then(data => {
        let datas = data.data;
        let { code, msg } = datas;
        if (code === 200) {
          this.$message({
            message: msg,
            type: "success"
          });
          this.removeDialog = false;
          this.getList();

          if (this.RemPageIndex === 0) {
            this.paging = 1;
          } else if (this.RemPageIndex === 1) {
            --this.paging;
            if (this.paging <= 0) {
              this.paging = 1;
            }
          }
        } else {
          this.$message({
            message: msg,
            type: "error"
          });
          this.removeDialog = false;
        }
      });
    },
    // getData() {
    //   this.getTableData(apis.category_list, "get", this.search);
    // },
    reset() {
      this.search = {};
      this.ruleForm.name = "";
      this.search.page_index = 1;
      this.getList();
    },
    deleteData(id) {
      alert
        .deleteAlert()
        .then(res => {
          this.$axios.delete(apis.category_delete + "/" + id).then(res => {
            if (res.data.code === 200) {
              this.getData();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        })
        .catch(err => {});
    },
    openAdd(id) {
      this.$router.push({
        name: "shoppingCategoryUpdate",
        query: {
          id: id,
          operateType: "add"
        }
      });
    }
  }
};
</script>

<style>
.footer {
  display: flex;
  justify-content: center;
}
.customIpt {
  width: 260px;
}
</style>

<style lang="scss" scoped>
/*弹窗*/
.el-icon-warning {
  color: #e6a23c;
  font-size: 60px;
}
.Main {
  text-align: center;
  .infoOne {
    font-size: 28px;
    line-height: normal;
  }
  .infoTwo {
    padding-top: 10px;
    font-size: 14px;
  }
}
</style>
